import * as actionTypes from './ActionTypes';
import {postRequest, getRequest,putRequest} from '../Helper/ApiHit';

/*--------------------Payment Initiate API Atishay Start-----------------------------------------*/
export const getPaymentInitiate = (formData) => {
    return (dispatch) => {
        dispatch({type:actionTypes.ADMIN_PAYMENT_INITIATE});
            postRequest('employer/initiatePayment',formData)
            .then(res=>{
                if(res.data.responseStatus.statusCode === 0){
                    return dispatch({
                        type:actionTypes.ADMIN_PAYMENT_SUCCESS,
                        payload: res.data.responseData,
                    })
                }
               else{
                return dispatch({
                    type:actionTypes.ADMIN_PAYMENT_FAIL,
                    payload: res.data.responseData.message
                })
               }
            })
            .catch(err=>{
              
                return dispatch({
                    type: actionTypes.ADMIN_PAYMENT_NETWORK_ERROR,
                    payload: err.message
                })
            })
    }
}
/*--------------------Payment Initiate API Atishay Ends-----------------------------------------*/



/*------------------------Interview Get INTERVIEW LIST FOR ADMIN Start ---------------------------------- */
export const getInterviewListAdmin=(limit, page)=>{
    return dispatch=>{
        dispatch({type:actionTypes.ADMIN_INTERVIEW_LIST_INITIATE});
       // getRequest('employer/getInterviewListForPaymentForAdmin?limit='+limit+'&page='+page).then(res=>{

            getRequest('employer/checkPaymentStatus').then(res=>{
       
         if(res.data.responseStatus.statusCode ===0 ){
             return dispatch({
                 type:actionTypes.ADMIN_INTERVIEW_LIST_SUCCESS,
                 interviewList :res.data.responseData.checkPaymentStatus,
                // InterviewPagination:res.data.responseData.totalNumberOfPagesAsPerGivenPageLimit,
             })    
         }
         else{
             return dispatch({
                 type:actionTypes.ADMIN_INTERVIEW_LIST_FAIL,
                 interviewErrorMsg:res.data.responseData
             })
         }
        })
        .catch(error =>{
            return dispatch({ type:actionTypes.ADMIN_INTERVIEW_LIST_NETWORK_ERROR})
        })
    }
}

/*------------------------Interview Get INTERVIEW LIST FOR ADMIN Ends ---------------------------------- */
/*-------------------Make Security Deposit Payment ---------------------------------------------*/

export const makeSecurityDepositPayment = (amount) => {
    return (dispatch) => {
        dispatch({type: actionTypes.SECURITY_DEPOSIT_PAYMENT_INITIATE});
        postRequest('employer/makeSecurityDepositPayment', {"amount": amount})
        .then(res =>{
            if(res.data.responseStatus.statusCode === 0){
                return dispatch({
                    type:actionTypes.SECURITY_DEPOSIT_PAYMENT_SUCCESS,
                    payload: res.data.responseData,
                })
            }
           else{
            return dispatch({
                type:actionTypes.SECURITY_DEPOSIT_PAYMENT_FAIL,
                payload: res.data.responseData.message
            })
           }
        })
        .catch(err=>{
            return dispatch({
                type: actionTypes.SECURITY_DEPOSIT_PAYMENT_NETWORK_ERROR,
                payload: err.message
            })
        })
    }
}
/*----------------------------Make Payment Api Admin Atishay Start---------------------------------- */
export const makePayment = (data)=>{
    return (dispatch)=>{
        dispatch({type:actionTypes.MAKE_PAYMENT_INITIATE});
        postRequest('employer/makePayment',data)
        .then(res=>{
            if(res.data.responseStatus.statusCode === 0){
                return dispatch({
                    type:actionTypes.MAKE_PAYMENT_SUCCESS,
                    payload: res.data.responseData,
                })
            }
            else{
                return dispatch({
                    type:actionTypes.MAKE_PAYMENT_FAIL,
                    payload: res.data.responseData.message,
                })
            }
        })
        .catch(err =>{
            return dispatch({
                type: actionTypes.MAKE_PAYMENT_NETWORK_ERROR,
                payload: err.message
            })
        })
    }
}
/*----------------------------Make Payment Api Admin Atishay Ends---------------------------------- */

//getInterviewListForPaymentForNonAdmin Brijesh Start


export const getInterviewListForPaymentForNonAdmin=(page,data)=>{
 
    return dispatch=>{
        dispatch({type:actionTypes.GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_INITIATE});
        postRequest(`employer/getInterviewListForPaymentForNonAdmin?page=${page}&limit=7`, {
             interviewCheck: data
        }).then(res=>{
         if(res.data.responseStatus.statusCode ===0 ){
          
             return dispatch({
                 type:actionTypes.GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_SUCCESS,
                 paymentListData :res.data.responseData.paymentListData,
                 totalCount:res.data.responseData.totalCount,
             })    
         }
         else{
          
             return dispatch({
                 type:actionTypes.GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_FAIL,
                 interviewErrorMsg:res.data.responseData
             })
         }
        })
        .catch(error =>{
            return dispatch({ type:actionTypes.GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_NETWORK_ERROR})
        })
    }
}
/*----------------------------Make Payment Api Admin Atishay Ends---------------------------------- */


//-----------Confirm Payment Status   Nikhil----------------------

export const confirmPaymentStatus = (orderId) =>{
    return dispatch =>{
        dispatch({type: actionTypes.CONFIRM_PAYMENT_STATUS_INITIATE})
        postRequest('employer/confirmPaymentStatus', {
            "orderId": orderId
        })
        .then(res => {
            if(res.data.responseStatus.statusCode === 0){
                return dispatch({
                    type: actionTypes.CONFIRM_PAYMENT_STATUS_SUCCESS,
                    payload: res.data.responseData.paymentStatus,
                })
            }
            else{
                return dispatch({
                    type: actionTypes.CONFIRM_PAYMENT_STATUS_FAIL,
                    payload: res.data.responseData.message
                })
            }
        })
        .catch(error => {
            return dispatch({
                type: actionTypes.CONFIRM_PAYMENT_STATUS_NETWORK_ERROR
            })
        })
    }
}
/*----------------------------Make Payment Api Admin Atishay Ends---------------------------------- */

/*----------------------------Payment Invoice List Atishay Starts---------------------------------- */
export const getPaymentInvoiceList=(limit, page)=>{
    return dispatch=>{
        dispatch({type:actionTypes.PAYMENT_INVOICE_LIST_INITIATE});
        getRequest('employer/getPaymentInvoiceList?limit='+limit+'&page='+page).then(res=>{
           
         if(res.data.responseStatus.statusCode ===0 ){
             return dispatch({
                 type:actionTypes.PAYMENT_INVOICE_LIST_SUCCESS,
                 invoiceList :res.data.responseData,
             })    
         }
         else{
             return dispatch({
                 type:actionTypes.PAYMENT_INVOICE_LIST_FAIL,
                 invoiceErrorMsg:res.data.responseData
             })
         }
        })
        .catch(error =>{
            return dispatch({ type:actionTypes.PAYMENT_INVOICE_LIST_NETWORK_ERROR})
        })
    }
}

/*----------------------------Payment Invoice List Atishay Ends---------------------------------- */


/*----------------------------Payment Invoice Details Atishay Starts----------------------------- */
export const getPaymentInvoiceDetails=(id)=>{
    return dispatch=>{
        dispatch({type:actionTypes.PAYMENT_INVOICE_DETAILS_INITIATE});
        getRequest('employer/getPaymentInvoiceDetails?invoiceId='+id).then(res=>{
           
         if(res.data.responseStatus.statusCode ===0 ){
             return dispatch({
                 type:actionTypes.PAYMENT_INVOICE_DETAILS_SUCCESS,
                 invoiceDetails :res.data.responseData,
             })    
         }
         else{
             return dispatch({
                 type:actionTypes.PAYMENT_INVOICE_DETAILS_FAIL,
                 interviewErrorMsg:res.data.responseData
             })
         }
        })
        .catch(error =>{
            return dispatch({ type:actionTypes.PAYMENT_INVOICE_DETAILS_NETWORK_ERROR})
        })
    }
}

export const resetState=()=>{
    return  dispatch=>{
    dispatch({ type:actionTypes.PAYMENT_INVOICE_DETAILS_RESET_STATE})
    }
}

/*----------------------------Payment Invoice Details Atishay Ends----------------------------- */



/*----------------------------Payment ORDER HISTORY Atishay Starts----------------------------- */
export const getOrderHistory=(id,limit)=>{
   
    return dispatch=>{
        dispatch({type:actionTypes.ORDER_HISTORY_INITIATE});
        getRequest('employer/getEmployerSecurityDepositHistory').then(res=>{
           
         if(res.data.responseStatus.statusCode ===0 ){
             return dispatch({
                 type:actionTypes.ORDER_HISTORY_SUCCESS,
                 orderData :res.data.responseData,
             })    
         }
         else{
             return dispatch({
                 type:actionTypes.ORDER_HISTORY_FAIL,
                 interviewErrorMsg:res.data.responseData
             })
         }
        })
        .catch(error =>{
            return dispatch({ type:actionTypes.ORDER_HISTORY_NETWORK_ERROR})
        })
    }
}
/*----------------------------Payment ORDER HISTORY Atishay Ends----------------------------- */
/*----------------------------Payment Invoice Details Atishay Ends----------------------------- */

//approvePaymentByNonAdmin Brijesh Start


export const approvePaymentByNonAdmin=(arr,data,page)=>{
    return dispatch=>{
        dispatch({type:actionTypes.GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_INITIATE});
        postRequest('employer/approvePaymentByNonAdmin',
        {
            "interviewIds": arr
        }
        ).then(res=>{
         if(res.data.responseStatus.statusCode ===0 ){
          
            //1
            postRequest(`employer/getInterviewListForPaymentForNonAdmin?page=${page}&limit=7`, {
                interviewCheck: data
           }).then(res=>{
                if(res.data.responseStatus.statusCode ===0 ){
                 
                    return dispatch({
                        type:actionTypes.GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_SUCCESS,
                        paymentListData :res.data.responseData.paymentListData,
                        totalCount:res.data.responseData.totalCount,
                    })    
                }
                else{
                 
                    return dispatch({
                        type:actionTypes.GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_FAIL,
                        interviewErrorMsg:res.data.responseData
                    })
                }
               })
               .catch(error =>{
                   return dispatch({ type:actionTypes.GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_NETWORK_ERROR})
               })
           
            //2

             return dispatch({
                 type:actionTypes.APPROVE_PAYMENT_BYNONADMIN_SUCCESS,
                 paymentStatusUpdate :res.data.responseData.paymentStatusUpdate,
             })    
         }
         else{
          
             return dispatch({
                 type:actionTypes.APPROVE_PAYMENT_BYNONADMIN_FAIL,
             })
         }
        })
        .catch(error =>{
         
            return dispatch({ type:actionTypes.APPROVE_PAYMENT_BYNONADMIN_NETWORK_ERROR})
        })
    }
}



/*----------------------------getInvoiceDetailsBeforePayment List Atishay Starts---------------------------------- */
export const getInvoiceDetailsBeforePayment=()=>{
    return dispatch=>{
        dispatch({type:actionTypes.GET_INVOICE_DETAILS_BEFORE_PAYMENT_INITIATE});
        getRequest('employer/getInvoiceDetailsBeforePayment').then(res=>{
           
         if(res.data.responseStatus.statusCode ===0 ){
             return dispatch({
                 type:actionTypes.GET_INVOICE_DETAILS_BEFORE_PAYMENT_SUCCESS,
                 invoiceDetails :res.data.responseData,
             })    
         }
         else{
             return dispatch({
                 type:actionTypes.GET_INVOICE_DETAILS_BEFORE_PAYMENT_FAIL,
                 interviewErrorMsg:res.data.responseData
             })
         }
        })
        .catch(error =>{
            console.log(error)
            return dispatch({ type:actionTypes.GET_INVOICE_DETAILS_BEFORE_PAYMENT_NETWORK_ERROR})
        })
    }
}

/*----------------------------getInvoiceDetailsBeforePayment List Atishay Ends---------------------------------- */
